import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import OperatingSystem from "../../Components/OperatingSystem";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import CouponScrollBar from "../../Components/CouponScrollBar";


export default function DedicatedServerUAE() {
    const [applyPaddingClass, setApplyPaddingClass] = useState(false);
    useEffect(() => {
        document.title = "Dedicated Server UAE | Secure & Fast Hosting";
        sal();
    }, []);
    const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>Dedicated Server UAE | Secure & Fast Hosting</title>
        <meta name="description" content="Host your business on powerful dedicated servers in UAE with low latency, enterprise security, and scalable resources for growing workloads." />
        <meta name="keywords" content="Dedicated Server, Managed Dedicated Server, Dedicated Server UAE" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/dedicated-server-uae`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/dedicated-server-uae`} />
        <meta property="og:title" content="Dedicated Server in UAE: Elevate Performance and Security" />
        <meta property="og:description" content="Boost your business processes with a dedicated server in UAE. Tailored solutions with high security and performance built to fulfill your business needs." />
    </Helmet>
    <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="text-center">
                        <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Server's That Don't Sleep</span>
                        <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Your Business Deserves Better: Choose Dedicated Server UAE.</h1>
                        <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">If your site lags the most at the time of high traffic, that’s a red flag. You’ve grown faster than almost fast.” Choose a dedicated server UAE and give your business everything it deserves.</p>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap sal-animate pb-5" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-light btn-arrow btn-arrow-lg btn-lg fs-14 fw-semibold rounded transition btn-height">
                                <span className="btn-arrow__text">
                                    View Pricing
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                        </div>
                        <span>
                            <MinPlanPrice category="customizedduae" />
                        </span>
                        <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="simple-box-section pt-100 pb-100">
      <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card-body px-6 pt-60 pb-60">
                        <div className="row justify-content-center">
                            <div className="col-md-11 col-lg-8 col-xl-8">
                                <div className="text-center">
                                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">No More Location Issues</span>
                                    <h4 className="mb-4">
                                        Still Hosting in the Worst Time Zone? Don’t Worry.
                                    </h4>
                                    <p className="mb-6">
                                      Yes, that unexpected delay? They feel it. That 3 AM crash? They don’t forget it. With different server locations across many countries and cities, you have a range of options.
                                    </p>
                                    <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded open-live-chat btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comments"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            Talk to an Expert
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>

    <section className="bg-white pt-100 pb-100">
        <div className="container">
            <div className="row">
                <div className="col-xl-8">
                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Our Dedicated Server UAE</span>
                    <h2 className="mb-0">Two Words: High Speed. Three Words: Dedicated Server UAE.</h2>
                </div>
            </div>
            <div className="pt-40">
                <div className="row g-4">
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3 h-100">
                            <img src="images/control-uae-server.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Control: UAE Server</h5>
                            <p className="text-dark mb-0">If full access is your love language, this is your perfect match. A UAE dedicated server always puts you in charge.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3 h-100">
                            <img src="images/0-to-10-gbps.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">0 to 10 Gbps Speed</h5>
                            <p className="text-dark mb-0">Why crawl slowly like a snail when you can fly with our Server Hosting Dubai? With 10 Gbps speed, your site content loads in a blink.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3 h-100">
                            <img src="images/it’s-your-rules-now.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">It’s Your Rules Now</h5>
                            <p className="text-dark mb-0">With our Dedicated Server UAE, you are completely in control, ranging from settings to high security. Personalize it according to you.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3 h-100">
                            <img src="images/compatibility-done.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Compatibility? Done.</h5>
                            <p className="text-dark mb-0">Run all your demanded tools, your way. Server Hosting Dubai is engineered to play nice with everything you want-no restrictions.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3 h-100">
                            <img src="images/up-&-running.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Up & Running in a Flash</h5>
                            <p className="text-dark mb-0">With our Dedicated Server Hosting Dubai, your server goes live in no time, so you can launch, develop, and adjust without missing a beat.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-4">
                        <div className="bg-grey-custom px-8 py-10 rounded-3 h-100">
                            <img src="images/only-for-your-needs.webp" alt="Image" className="img-fluid mb-6" />
                            <h5 className="mb-5">Only For Your Needs </h5>
                            <p className="text-dark mb-0">Want that “just right” feeling? It's possible with our dedicated server UAE adapts to your requirements-nothing extra, nothing skipped.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="price-plan-section pt-100 pb-100">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="text-center">
                            <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                            <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Plans That Scale With You</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PlanList category={'customizedduae'}/>
    </section>

    <section className="pt-100 pb-100">
        <div className="container">
            <div className="row">
                <div className="col-xl-6">
                    <h2 className="mb-8">Why UAE’s Top Performers Choose Infinitive Host?</h2>
                </div>
            </div>
            <div className="row align-items-end g-4">
                <div className="col-xl-6">
                    <img src="images/lag-not-in-our.webp" alt="image" className="img-fluid full-width-img" />
                </div>
                <div className="col-xl-6 ipad-pro-mt">
                    <div className="">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="bg-white p-8 rounded-4 h-100">
                                    <img src="images/fast-far-everywhere.webp" alt="icon" className="img-fluid mb-4" />
                                    <h6 className="mb-3">Fast. Far. Everywhere.</h6>
                                    <p className="mb-0">It doesn’t matter where your site users are clicking from. With our worldwide data centers-mainly our Dubai dedicated server-you get the expected reach.</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="bg-white p-8 rounded-4 h-100">
                                    <img src="images/beyond-hackers.webp" alt="icon" className="img-fluid mb-4" />
                                    <h6 className="mb-3">Beyond Hackers' Reach</h6>
                                    <p className="mb-0">With a UAE Dedicated Server, your site lives in a safe zone that hackers can’t reach. With high control, everything is built to remain safe.</p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="bg-white p-7 rounded-4 d-flex align-items-center flex-wrap flex-sm-nowrap gap-6 position-relative z-1">
                                    <img src="images/event-8-shape.png" alt="image" className="img-fluid position-absolute top-0 end-0 z-n1" />
                                    <img src="images/no-downtime-no.webp" alt="image" className="img-fluid" />
                                    <div>
                                        <h6 className="mb-3">No Downtime, No Loss</h6>
                                        <p className="mb-0"> Your visitors don’t wait for a very long time or neither should your website. With our Dedicated Server UAE, you’re live and fast, 24/7. No more “sorry, we’re down” moments-just seamless, high power.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div className="container pt-60 pb-60">
        <div className="row">
            <div className="col-12">
                <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-12 col-lg-7 col-xl-5">
                            <h2 className="text-white">
                                Perks of a Dedicated Server Hosting Dubai!
                            </h2>
                            <p className="mb-8 text-white text-opacity-75">
                                Step into the VIP lane with a dedicated server UAE-where high speed meets constant stability,
                                and your website never settles for the bare minimum.
                            </p>
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                        </div>
                        <div className="col-xl-7 ipad-pro-mt">
                            <div className="row g-4 g-xl-0 feature-card">
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/sites-that-never.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Set Up That Just Gets You
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Begin your experience without any chaos. Our Dubai dedicated server is prepared, trained, and ideally in sync with your wishes.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/set-it-up-in-a-go.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Set It Up In a Go
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Why wait too long when all your goals are set to launch? Our UAE server  comes with single-click installation for CMS platforms.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/speed-that-actually.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Break the Speed Limits
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Speed isn’t all about luxury; it becomes a necessity. Our dedicated server hosting Dubai offers exceptional performance.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/go-hard-or-lag.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Go Hard or Lag Home
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Our UAE dedicated server runs on today's hardware that’s crafted to think & act quickly. Even if it’s your site, it runs like it’s for you.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/day-or-night.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Day or Night, We’re Up
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Tech issues don’t check the clock or time before occurring. Even if it's 3 AM or 3 PM, our expert team’s on it-always, anytime.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6 feature-card__list">
                                    <div className="feature-card__is border border-light border-opacity-25 rounded-3">
                                        <div className="mb-4">
                                            <img src="images/not-just-access.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-4 text-white">
                                            Not Just Access
                                        </h6>
                                        <p className="mb-0 text-light text-opacity-50">
                                            Say hi to your chosen server, your empire. Full admin access gives you all the keys to personalize and control your server.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                </div>
            </div>
        </div>
    </div>

    <OperatingSystem/>
    <section className="pt-60 pb-100">
        <div className="container">
            <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-9">
                        <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                <small className="text-primary fw-bold">Don't Think, Just Bloom</small>
                            </div>
                        </div>
                        <div className="text-center mt-5">
                            <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">No More Tomorrow. Today’s the Perfect Day. Let’s Do This.</h2>
                            <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">UAE’s Trusted Hosting That Keeps Up with Your Grind. </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Start Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                            <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Learn More
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  );
}
